import * as React from "react";
import { Bar, BarChart, Legend, Tooltip, XAxis, YAxis } from "recharts";
import { useSortedByCategory } from "../../../Helper/CategorySortHelper";

const UnserviceableServiceLevelBarChartComponent = ({ data }) => {
  const processedData = useSortedByCategory(data || [], "category").map(item => {
    const total = item.onTime + item.delayed;
    return {
      ...item,
      // contractName zaten item içinde geliyor
      serviceLevel: total > 0 ? parseFloat(((item.onTime / total) * 100).toFixed(2)) : 0,
      delayLevel: total > 0 ? parseFloat(((item.delayed / total) * 100).toFixed(2)) : 0,
    };
  });

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload }: any) => {
    if (!active || !payload?.[0]) return null;

    const data = payload[0].payload;

    return (
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "10px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', color: '#333' }}>
                    {data.contractName}
                </p> */}
        <p style={{ margin: "4px 0", color: "#666" }}>
          Category: <strong>{data.category}</strong>
        </p>
        <p style={{ margin: "4px 0", color: "#45B4C8" }}>
          Service Level: <strong>{data.serviceLevel}%</strong>
        </p>
        <p style={{ margin: "4px 0", color: "#FF0000" }}>
          Delay Level: <strong>{data.delayLevel}%</strong>
        </p>
      </div>
    );
  };

  return (
    <>
      <BarChart width={900} height={600} data={processedData} margin={{ top: 60, right: 50, left: 50, bottom: 140 }}>
        <XAxis
          type="category"
          dataKey="category"
          angle={-45}
          textAnchor="end"
          height={140}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <YAxis type="number" tickFormatter={value => `${value}%`} />
        <Tooltip cursor={false} content={<CustomTooltip />} />
        <Legend
          verticalAlign="top"
          height={36}
          payload={[
            { value: "Delay Level", type: "line", id: "delayLevel", color: "#FF0000" },
            { value: "Service Level", type: "line", id: "serviceLevel", color: "#45B4C8" },
          ]}
        />
        <Bar dataKey="serviceLevel" stackId="a" fill="#45B4C8" isAnimationActive={false} barSize={30} />
        <Bar dataKey="delayLevel" stackId="a" fill="#FF0000" isAnimationActive={true} barSize={20} />
      </BarChart>
    </>
  );
};

export default UnserviceableServiceLevelBarChartComponent;
